/*
 * =============================================================================
 * FILE HEADER — apps/studio/src/main.tsx
 * =============================================================================
 *
 * CHANGE LOG
 * ----------
 * | # | Date & Time (IST)    | Who               | Why                    | What Changed         |
 * |---|----------------------|-------------------|------------------------|----------------------|
 * | 1 | 2026-06-15 (Step 2)  | Claude Sonnet 4.6 | Studio SPA setup       | Created from scratch |
 *
 * WHICH FILE CALLS / IMPORTS THIS FILE
 * --------------------------------------
 * - apps/studio/index.html  (<script type="module" src="/src/main.tsx">)
 * - Not imported by any other module.
 *
 * FUNCTIONS / EXPORTS COVERED
 * ----------------------------
 * No exports. Side-effect: mounts React <App /> into #root.
 *
 * CALLER → CALLEE MAP
 * --------------------
 * index.html → main.tsx → ReactDOM.createRoot → <App />
 *
 * IMPORTANT POINTS
 * -----------------
 * 1. StrictMode is on in development. It double-invokes effects and renders
 *    to surface side-effect bugs early. This is intentional — do not remove.
 * 2. The #root element is guaranteed by index.html. The non-null assertion
 *    is safe; if it's ever missing, crashing loudly is correct behavior.
 * 3. import './index.css' applies global resets before React hydrates.
 *
 * ISSUES FACED / KNOWN GOTCHAS
 * -----------------------------
 * None yet (stub phase — full recorder/editor wired in Phase 3, Steps 25-33).
 *
 * =============================================================================
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.js";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
